import { Injectable, inject } from '@angular/core';
import { HttpClient , HttpParams} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {Observable, of, throwError} from 'rxjs';
import {OfferGroup} from '../models/offer-group.model';
import {Offer} from '../models/offer.model';
import {Globals} from '../../core/globals';
import {ImageService} from "../../core/services/image.service";
import {Bonus} from "../models/bonus.model";
import {ArticleDetail} from "../models/article-detail";
import {ImageHandler} from "../../core/services/image-handler.service";
import {TranslationService} from "../../core/services/translation.service";

@Injectable({providedIn: 'root'})
export class OfferService {
  private http = inject(HttpClient);
  private imageService = inject(ImageService);
  private imageHandler: ImageHandler = inject(ImageHandler);
  private translationService: TranslationService = inject(TranslationService);

  private offers: Offer[] = [];
  private minimal: Offer[] = [];
  private offerGroups: OfferGroup[] = [];
  loadedAllOffers = false;
  loadedAllMinimalOffers = false;

  getMinimalOffers(loadImages: boolean = false) {
    if (this.loadedAllMinimalOffers) {
      return of(this.minimal);
    } else {
      return this.loadOffers(true, loadImages);
    }
  }

  getOffers(): Observable<Offer[]> {
    if (this.loadedAllOffers) {
      return of(this.offers);
    } else {
      /*
      const offerData = JSON.parse(localStorage.getItem('offers'));
      if (offerData && new Date(offerData.expirationDate) > new Date()) {
        this.offers = offerData.offers;
        return of(this.offers);
      }
       */
      return this.loadOffers(false, true);
    }
  }

  getArticleDescriptionFromId(articleId: string) {
    return this.http.get<ArticleDetail>('/webabo/articles/' + articleId + '/description')
      .pipe(map(response => response));
  }

  private loadOffers(loadMinimal: boolean = false, loadImages: boolean = false) {
    const url = loadMinimal ? '/webabo/offers/minimal' : '/webabo/offers';
    return this.http.get<Offer[]>(url).pipe(map(offers => {
      if (loadImages) {
        this.loadImagesOfOffer(offers);
      }

      if (loadMinimal) {
        this.loadedAllMinimalOffers = true;
        offers.forEach(offer => {
          offer.description = offer['title'];
          offer.summary = offer['webDescription'];
          offer.orderChoiceKey = offer['orderChoiceKey'];
        });
        this.minimal = offers;
      } else {
        this.offers = offers;
        this.loadedAllOffers = true;
        const expirationDate = new Date();
        expirationDate.setSeconds(expirationDate.getSeconds() + Globals.CACHE_TIME_BASE_DATA);
        localStorage.setItem('offers', JSON.stringify({expirationDate, offers}));
      }
      return offers;
    }));
  }

  private loadImagesOfOffer(offers: Offer[]) {
    offers.forEach(offer => {
      let altText = '';
      this.imageService.getImageOfOffer(offer.recno).subscribe(image => {
        if (image) {
          altText = offer.description ?? this.translationService.getTranslation('offer.image.altText.default');
          offer.image = this.imageHandler.addAltText(image, altText);
        }
      });
      this.imageService.getConfirmationImageOfOffer(offer.recno).subscribe(image => {
        if (image) {
          altText = offer.confirmationText ?? this.translationService.getTranslation('offer.confirmationImage.altText.default');
          offer.confirmationImage = this.imageHandler.addAltText(image, altText);
        }
      });
      const newBonusList = [];
      offer.bonusList?.forEach((bonus: any) => {
        const newBonus = new Bonus(bonus.id ?? bonus.articleCode, bonus.name,
          bonus.description, null, -1, -1, bonus.available, bonus.weight,
          bonus.image, 1, bonus.bonusType, false,
          bonus?.clientCoPayment,  bonus?.isoCurrencyCode,bonus?.creditCheckRequired);
        this.imageService.getImageOfArticle(newBonus.articleCode).subscribe(image => {
            if (image) {
              altText = bonus.name ?? this.translationService.getTranslation('bonus.image.altText.default');
              newBonus.image = this.imageHandler.addAltText(image, altText);
            }
          }
        )
        newBonusList.push(newBonus);
      });
      offer.bonusList = newBonusList;
    });
  }

  getOfferDetail(orderChoiceKey: number): Observable<Offer> {
    for (const offer of this.offers) {
      if (offer.orderChoiceKey === orderChoiceKey) {
        return of(offer);
      }
    }
    return this.http.get<Offer>('/webabo/offers/byOrderChoiceKey/' + +orderChoiceKey).pipe(map(offer => {
      if (offer) {
        this.loadImagesOfOffer([offer]);
        this.offers.push(offer);
        return offer;
      } else {
        of(null);
      }
    }),
      catchError(error => {
        return of(null);
      })
    );
  }


  getOfferGroups(): Observable<OfferGroup[]> {
    /*
    const offerGroupsData = JSON.parse(localStorage.getItem('offerGroups'));
    if (offerGroupsData && new Date(offerGroupsData.expirationDate) > new Date()) {
      this.offerGroups = offerGroupsData.offerGroups;
      return of(this.offerGroups);
    }
     */
    return this.http.get<OfferGroup[]>('/webabo/offers/groups').pipe(map(offerGroups => {
      this.offerGroups = offerGroups;
      offerGroups.forEach(group => {
        group.image = this.imageHandler.addAltText(group['groupImg'], group.description ?? this.translationService.getTranslation('offerGroup.image.altText.default'));
      })

      const expirationDate = new Date();
      expirationDate.setSeconds(expirationDate.getSeconds() + Globals.CACHE_TIME_BASE_DATA);
      //TODO P5W-2667: Ausgebaut, weil Bilder im Safari den Local Storage sprengen.
      // Wieder einbauen, wenn Bilder direkt aus dem Alfresco geladen werden können.
      //localStorage.setItem('offerGroups', JSON.stringify({expirationDate, offerGroups}));
      return this.offerGroups;
    }));
  }
}
